import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';

export class ElementBaseCopyUiModel {
    private model: IElementBaseModel;
    public constructor(model: IElementBaseModel) {
        this.model = model;
    }

    /**
     * 创建ui-model的副本
     */
    public getCopiedUiModelWithSdkModel(emptyCopiedUIModel: IElementBaseModel): IElementBaseModel | null {
        emptyCopiedUIModel.sdkData = this.model.sdkData;
        emptyCopiedUIModel.parent = this.model.slideRef;
        emptyCopiedUIModel.asyncConvertChildren = false;
        // @ts-ignore
        emptyCopiedUIModel.doConvertSdkDataModelToUiData(this.model.sdkData).catch();
        emptyCopiedUIModel.isPlaceholder = false;
        if (this.model.placeHolder) {
            emptyCopiedUIModel.placeHolder = undefined;
        }
        return emptyCopiedUIModel;
    }
}
